import * as React from 'react';

export function ListFilterIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			strokeLinejoin='round'
			strokeLinecap='round'
			strokeWidth={2}
			stroke='currentColor'
			fill='none'
			viewBox='0 0 24 24'
			width={24}
			height={24}
			{...props}
		>
			<path d='M2 5h20' />
			<path d='M6 12h12' />
			<path d='M9 19h6' />
		</svg>
	);
}
